module.exports = __webpack_public_path__ + "img/img_phone3_SFA.d09ab04f.png";